<template>
    <div>
        <FormTitle title="短信详情"/>
        <a-form @submit="handleSubmit" :form="form">
           

            <a-form-item label="短信签名" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signname',
                        {
                            initialValue: record.signname,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="短信签名编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signcode',
                        {
                            initialValue: record.signcode,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="申请人" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'applyusercode',
                        {
                            initialValue: record.applyusercode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="申请人" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'applyusername',
                        {
                            initialValue: record.applyusername,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="签名申请平台" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'plateoriginname',
                        {
                            initialValue: record.plateoriginname,
                        }
                    ]"
                />
           </a-form-item>
           <a-form-item label="签名作用域" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signtypename',
                        {
                            initialValue: record.signtypename,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="签名审核状态" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signstatusname',
                        {
                            initialValue: record.signstatusname,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="签名来源名称" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signoriginname',
                        {
                            initialValue: record.signoriginname,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="三证合一" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'applytypename',
                        {
                            initialValue: record.applytypename,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="签名对应编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signnamecode',
                        {
                            initialValue: record.signnamecode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="申请签名照片" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                 <a-textarea cols="100" rows="8"
                    style="width:700px" 
                    v-decorator="[
                        'applypics',
                        {
                            initialValue: record.applypics,
                        }
                    ]"
                 />
            </a-form-item>
            <a-form-item label="remark" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        '申请说明',
                        {
                            initialValue: record.申请说明,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="驳回原因" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-textarea
                    style="width:500px"
                    v-decorator="[
                        'reason',
                        {
                            initialValue: record.reason,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="提交审核时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'applytime',
                        {
                            initialValue: record.applytime,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="阿里云返回的请求id" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'requestid',
                        {
                            initialValue: record.requestid,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="创建时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'createtime',
                        {
                            initialValue: record.createtime,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="创建人" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'createuser',
                        {
                            initialValue: record.createuser,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-model-item   style="text-align: center">
                <a-button type="primary" @click="refresh">
                    刷新状态
                </a-button>

                <a-button type="primary" style="margin-left: 20px;" @click="handleCancel">
                    返回
                </a-button>    
            </a-form-model-item>
        </a-form>
    </div>
</template>

<script>
import FormTitle from "../../../components/FormTitle.vue";
import { mapState } from "vuex";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 }
};

export default {
    data() {
        return {
            formItemLayout,
            formLayout: "horizontal",
            form: this.$form.createForm(this),
            disabled:  true 
        };
    },
    computed: {
        ...mapState("smsmanager", {
            record: function(state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题
                return   state.record;
            }
        })
    },
    methods: {
        //域名信息表单提交
        handleSubmit(e) {
            e.preventDefault();
        },

        // 刷新签名申请状态
        refresh() {
            this.confirmLoading = true;
            let c_params = {};
            c_params.id=this.record.id;
            this.$store
                .dispatch({
                    type: "smsmanager/querySignApplyStatus",
                    params: c_params
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.confirmLoading = false;
                        this.message.success("更新成功！")
                        const { query } = this.$route;

                        this.$store.dispatch({
                            type: "smsmanager/detailSignApply",
                            params: query,
                            showMsg: false
                        });
                    }
                });
            
        },

        handleCancel() {
            this.$router.back(-1);
        },

    },
    mounted() {

        const { query } = this.$route;

        this.$store.dispatch({
            type: "smsmanager/detailSignApply",
            params: query,
            showMsg: false
        });
    },
    components: {
        FormTitle
    }
};
</script>

<style scoped>
</style>